import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import CarouselSlider from 'components/atoms/TemplateCarouselSlider_nobtn';
import { Slide } from 'pure-react-carousel';
import ReactHtmlParser from 'react-html-parser';

/**
 * Text
 */
const ListBtnElement = ({ onClickEvt, data, styleDef }) => {
  return (
    <div
      className="_list_btn_button"
      style={{ ...styleDef, padding: '10px' }}
      onClick={e => onClickEvt(data.value, data.action, data.label)}
      role="button"
      tabIndex={0}
      onKeyPress={e => {
        if (e.key === 'Enter') {
          onClickEvt(data.value, data.action, data.label);
        }
      }}
    >
      {ReactHtmlParser(data.label)}
    </div>
  );
};
const ListButtonCard = ({ boxStyle, item, viewType, onClickEvt }) => {
  const { items, type } = item;
  const slideBoxSet = boxStyle;
  const slideBoxSetStyle = {
    // width: `${slideBoxSet.width}px`,
    width: '160px',
    height: slideBoxSet.height,
    margin: '0 4px',
    outline: 'none',
  };

  const slideLength = items.length;
  const constentSet = () => {
    return (
      <>
        {items.map((tempItem, idx) => {
          return (
            <Slide key={`slide_${idx}`} index={idx} className="_list_btn_card" style={slideBoxSetStyle}>
              <div className="_list_btn_card_title">
                <div className="_title" style={boxStyle}>
                  {ReactHtmlParser(tempItem.text.desc)}
                </div>
              </div>
              {tempItem.button.map((data, number) => {
                return data.value && data.label ? <ListBtnElement key={'list_btn_ele_' + number} styleDef={boxStyle} onClickEvt={onClickEvt} data={data} /> : '';
              })}
            </Slide>
          );
        })}
      </>
    );
  };
  return (
    <>
      <div className="_carousel_button_div" style={{ width: '101%', margin: '0 0 0 0.22em' }}>
        <CarouselSlider slideBoxSet={{ width: 350, margin: 15, height: '200px' }} contentCount={slideLength} contentSet={constentSet} />
      </div>
    </>
  );
};
ListButtonCard.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
};
ListButtonCard.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  onClickEvt: null,
};

ListBtnElement.propTypes = {
  data: PropTypes.object,
  onClickEvt: PropTypes.func,
  styleDef: PropTypes.object,
};
ListBtnElement.defaultProps = {
  data: {},
  onClickEvt: null,
  styleDef: {},
};

export default ListButtonCard;
